import PropTypes from "prop-types";
import {useContext, useEffect} from "react";
import maplibregl from "maplibre-gl";
import {AppDataContext} from "../../App";

const MapSelectedMarkerLayer = ({map, lngLat, onClick}) => {

    useEffect(() => {

        if (!map || !lngLat) { return }

        const m = new maplibregl.Marker()
            .setLngLat(lngLat)
            .addTo(map)

        m.getElement().addEventListener("click", () => {
            onClick && onClick()
        })

        return () => {
            m.remove()
        }

    }, [map, lngLat])

}

MapSelectedMarkerLayer.propTypes = {
    map: PropTypes.any,
    lngLat: PropTypes.object,
    onClick: PropTypes.func,
}

export  default MapSelectedMarkerLayer
